import { ActionReducer } from '@ngrx/store';
import { AppState } from '../app.reducer';
import * as fromUser from './user.actions';
import { initialState, IUserState as UserState } from './user.reducer';
import { State as StateState } from './state.reducer';
import { updatingCurrentAddressAction } from './state.actions';
import { UploadStatus } from '../models/upload-status.model';

export const USER_STATE_VERSION = 4;
export const STATE_STATE_VERSION = 3;

export function getStoredUser(organizationId: string): UserState {
  const userData = localStorage.getItem(organizationId.toUpperCase() + '_User');
  let cachedUser: UserState | null = null;
  if (userData) {
    const cachedData: any = JSON.parse(userData);
    if (cachedData && cachedData.version === USER_STATE_VERSION) {
      cachedUser = cachedData.state;
    }
  }
  if (!cachedUser || cachedUser.organizationCode !== organizationId) {
    cachedUser = {
      ...initialState,
      organizationCode: organizationId,
    };
  } else {
    // что-то мы в стор не кладём, поэтому надо инициировать
    cachedUser.syncStatus = UploadStatus.NO;
    cachedUser.orders = [];
    cachedUser.ordersUploadStatus = UploadStatus.NO;
    cachedUser.successAuthBackPage = '';
  }
  return cachedUser;
}

export function getStoredState(organizationId: string): StateState {
  const stateData = localStorage.getItem(organizationId.toUpperCase() + '_State');
  const state: StateState = {
    organizationCode: organizationId,
    currentAddress: null,
    currentZone: null
  };
  if (stateData) {
    const cachedState = JSON.parse(stateData);
    if (cachedState && cachedState.version === STATE_STATE_VERSION) {
      state.currentAddress = cachedState.state.currentAddress;
    }
  }
  return state;
}

export function saveStateData(currentState: StateState): void {
  localStorage.setItem(currentState.organizationCode.toUpperCase() + '_State', JSON.stringify({
    version: STATE_STATE_VERSION,
    state: {
      currentAddress: currentState.currentAddress
    }
  }));
}

export function storageMetaReducer(
  reducer: ActionReducer<AppState>
): ActionReducer<AppState> {
  let wasAutoLogin = false;

  return (state, action) => {
    const nextState = reducer(state, action);

    // Начинаем переписывать стэйт только после авторизации или userAutoLoginAction или если отправили СМС
    if (
      action.type === fromUser.userLoginAction.type ||
      action.type === fromUser.userAutoLoginAction.type ||
      action.type === fromUser.userSendCodeAction.type
    ) {
      wasAutoLogin = true;
    }

    if (nextState.user.organizationCode) {


      if (action.type === fromUser.userLogoutAction.type) {
        localStorage.removeItem(nextState.user.organizationCode.toUpperCase() + '_User');
      }

      if (wasAutoLogin) {
        localStorage.setItem(nextState.user.organizationCode.toUpperCase() + '_User', JSON.stringify({
          version: USER_STATE_VERSION,
          state: {
            user: nextState.user.user,
            authToken: nextState.user.authToken,
            isAuthorized: nextState.user.isAuthorized,
            // не нужно это сохранять в сторе, чтобы случайно не получилось, что
            // пользователь не может больше попробовать отправить СМС
            isCodeSent: false,
            isCodeSentEarlier: false,
            organizationCode: nextState.user.organizationCode
          }
        }));
      }
    }

    // Если проставляют новый адрес, то сохраняем его
    if (action.type === updatingCurrentAddressAction.type) {
      saveStateData(nextState.state);
    }

    return nextState;
  };
}
